import { Controller, useFormContext } from "react-hook-form";
import { FormControl, FormHelperText, FormLabel } from "@mui/joy";
import { useParams } from "react-router-dom";
import { useGetTagsQuery } from "../api";
import { TagsSelect } from "./TagsSelect";

export function FormTagsInput({ name, label, optional }) {
  const form = useFormContext();
  const errors = form.formState.errors;
  const { householdId } = useParams();
  const { data: tagsData } = useGetTagsQuery({ householdId });

  const existingTags = tagsData?.data || [];

  return (
    <FormControl error={!!errors[name]}>
      <FormLabel>
        {label}
        {optional && (
          <span style={{ fontWeight: 'normal', color: 'var(--joy-palette-neutral-500)' }}> (optional)</span>
        )}
      </FormLabel>
      <Controller
        name={name}
        control={form.control}
        render={({ field: { ref, value = [], onChange } }) => (
          <TagsSelect
            ref={ref}
            value={value}
            onChange={onChange}
            options={existingTags}
            allowCreate
            sx={{ minWidth: 200 }}
          />
        )}
      />
      {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
    </FormControl>
  );
}
